import { defineStyleConfig } from '@chakra-ui/react'

const Heading = defineStyleConfig({
  sizes: {
    xs: {
      fontSize: 11,
      lineHeight: "16px"
    },
    sm: {
      fontSize: 12,
      lineHeight: "16px"
    },
    md: {
      fontSize: 16,
      lineHeight: "28px"
    },
    lg: {
      fontSize: 18,
      lineHeight: "24px"
    },
    xl: {
      fontSize: 24,
      lineHeight: "28px"
    },
  },
  defaultProps: {
    size: "md"
  }
})
export default Heading